module.exports = __webpack_public_path__ + "img/ybh.d057b0d3.png";